import React from "react"
import "semantic-ui-css/semantic.min.css"

import DateFilter from "./DateFilter"
import AmountFilter from "./AmountFilter"
import PlusFilter from "./PlusFilter"

const FilterButtonsTransactions = ({
  onBankTransfersDateFilterChange,
  onBankTransfersAmountFilterChange,
  ...logic
} = {}) => {
  return (
    <React.Fragment>
      <DateFilter
        onDateFilterChange={onBankTransfersDateFilterChange}
      />
      <AmountFilter
        onAmountFilterChange={onBankTransfersAmountFilterChange}
      />
      <PlusFilter {...logic} />
    </React.Fragment>
  )
}

export default FilterButtonsTransactions
